// extracted by mini-css-extract-plugin
export default {"cardClass":"cardClass---QdCrS","headerClass":"headerClass---Hw5dF","bodyClass":"bodyClass---VPkak"};